module.exports = __webpack_public_path__ + "img/no-day-recipe.043d42e0.svg";